import React from "react";
import AboutSection from "../components/About";

const About = () => {
  return (
    <div>
      <AboutSection />
    </div>
  );
};

export default About;
